import React from 'react';
import classNames from 'classnames';
import { mdiCheck, mdiMinus } from '@mdi/js';
import { Column, Row, Margin } from '@upgrade/react-components';

import Fluid from '../Fluid';
import { ResponsiveImage, Section, StyledLineHeader } from '../common/styles';
import { Heading, Text } from '../common/TypographyPublicSite';
import Highlights from '../common/HighlightsV2';
import { StyledHeroBanner, StyledHeroCTAButton } from './styles';
import { toHtmlSanitize } from '../../utils/remark-html';
import { StyledLink } from '../common/typography';
import Breadcrumb from '../common/Breadcrumb';

const Hero = ({
  banner,
  breadcrumb,
  bulletType,
  caption,
  hideImageOnMobile = true,
  highlights,
  image,
  imageAlt,
  learnMoreLinkText,
  learnMoreLinkUrl,
  learnMoreLinkAriaLabel,
  subtitle,
  title,
  ctaButtonText,
  ctaButtonAriaLabel,
  ctaLinkUrl,
  onCtaButtonClick
}) => {
  return (
    <Section borderless data-color="backgroundPage" padding="sm">
      <Fluid>
        {banner && (
          <StyledHeroBanner>
            <Text
              size="lg"
              dangerouslySetInnerHTML={{ __html: toHtmlSanitize(banner, { removeWrappingPTag: true }) }}
            />
          </StyledHeroBanner>
        )}
        <Row xsVerticalAlign="middle">
          <Column xs={12} sm={image ? 5 : 12}>
            {caption && <StyledLineHeader>{caption}</StyledLineHeader>}
            {breadcrumb && <Breadcrumb {...breadcrumb} />}
            <Margin top="sm">
              <Heading as="h1" size="md" color="actionableHover">
                {title}
              </Heading>
            </Margin>
            {subtitle && (
              <Margin top="sm">
                <Heading as="h2" size="xs">
                  {subtitle}
                </Heading>
              </Margin>
            )}
            {highlights?.length && (
              <Highlights
                items={highlights.map(highlight => ({
                  text: highlight.item
                }))}
                iconSize="1.25rem"
                icon={bulletType === 'dash' ? mdiMinus : mdiCheck}
              />
            )}
            {ctaButtonText ? (
              <Row>
                <Column xs={12} lg={10}>
                  <StyledHeroCTAButton
                    {...{
                      ctaButtonText,
                      linkUrl: ctaLinkUrl,
                      ariaLabel: ctaButtonAriaLabel,
                      buttonProps: { fullWidth: true, onClick: onCtaButtonClick }
                    }}
                  />
                  {learnMoreLinkUrl && learnMoreLinkText ? (
                    <Column xs={12} xsHorizontalAlign="center">
                      <Margin top="md">
                        <StyledLink to={learnMoreLinkUrl} aria-label={learnMoreLinkAriaLabel}>
                          <Text align="center" size="sm" bold>
                            {learnMoreLinkText}
                          </Text>
                        </StyledLink>
                      </Margin>
                    </Column>
                  ) : null}
                </Column>
              </Row>
            ) : null}
          </Column>
          {image ? (
            <Column xs={12} sm={7} xsHorizontalAlign="center">
              <Margin className={classNames({ 'hidden visible-sm': hideImageOnMobile })} top={{ xs: 'lg', sm: 'none' }}>
                <ResponsiveImage src={image} alt={imageAlt} />
              </Margin>
            </Column>
          ) : null}
        </Row>
      </Fluid>
    </Section>
  );
};

export default Hero;
